import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Bed, ExternalLink, MapPin, Phone } from "lucide-react";

const FALLBACK_BG = "https://static.prod-images.emergentagent.com/jobs/b659007a-b26e-4c48-80c7-ae6e37053ed8/images/95604de0c44d8f5c8a831f8f16e1312822d258b0b6c6e4aedc5f2b51a7968d27.png";

export default function Accommodations() {
  const [items, setItems] = useState([]);
  const [bg, setBg] = useState(FALLBACK_BG);
  const token = localStorage.getItem("ebel_token");

  useEffect(() => {
    api.get("/accommodations").then((r) => setItems(r.data));
    api.get("/info").then((r) => {
      if (r.data.accommodations_bg_id) {
        setBg(`${API}/photos/${r.data.accommodations_bg_id}/download?auth=${token}`);
      }
    });
  }, [token]);

  return (
    <div data-testid="accommodations-page">
      <section
        className="relative px-6 py-24"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(253,251,247,0.4), rgba(253,251,247,0.92)), url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-3xl mx-auto text-center">
          <p className="label-eyebrow mb-3">Schlafen & Ankommen</p>
          <h1 className="font-serif text-5xl lg:text-6xl tracking-tight">Übernachtungs&shy;möglichkeiten</h1>
          <p className="text-[#4A4F46] mt-4 leading-relaxed">
            Eine kleine Auswahl an Unterkünften in der Umgebung. Bitte rechtzeitig reservieren.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
        <div className="space-y-6">
          {items.map((it) => (
            <article
              key={it.id}
              className="bg-white border border-[#E5DFD3] rounded-2xl p-6 lg:p-8 hover:shadow-[0_12px_40px_-20px_rgba(72,99,74,0.3)] transition-shadow"
              data-testid={`accommodation-${it.id}`}
            >
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <div className="flex items-center gap-2 text-[#48634A] mb-1">
                    <Bed className="w-4 h-4" />
                    <span className="label-eyebrow">{it.distance || "Unterkunft"}</span>
                  </div>
                  <h2 className="font-serif text-3xl tracking-tight">{it.name}</h2>
                  {it.description && <p className="text-[#4A4F46] mt-2 leading-relaxed">{it.description}</p>}
                </div>
                {it.price_range && (
                  <div className="text-right">
                    <p className="label-eyebrow">Preis</p>
                    <p className="font-serif text-xl text-[#1A1C19]">{it.price_range}</p>
                  </div>
                )}
              </div>
              <div className="mt-5 pt-5 border-t border-[#E5DFD3] flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#4A4F46]">
                {it.phone && (
                  <a href={`tel:${it.phone}`} className="flex items-center gap-1.5 hover:text-[#48634A]" data-testid={`acc-phone-${it.id}`}>
                    <Phone className="w-4 h-4" /> {it.phone}
                  </a>
                )}
                {it.url && (
                  <a
                    href={it.url}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-1.5 text-[#48634A] hover:text-[#364A38]"
                    data-testid={`acc-url-${it.id}`}
                  >
                    <ExternalLink className="w-4 h-4" /> Webseite öffnen
                  </a>
                )}
              </div>
            </article>
          ))}
          {items.length === 0 && (
            <div className="text-center py-16 border border-dashed border-[#E5DFD3] rounded-2xl">
              <MapPin className="w-10 h-10 text-[#48634A] mx-auto mb-3" />
              <p className="font-serif text-2xl">Noch keine Unterkünfte hinterlegt</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
